import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, createVNode as _createVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("p", { class: "pogofilter__title" }, "Filter", -1)
const _hoisted_2 = /*#__PURE__*/_createElementVNode("div", { class: "pogofilter__content" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "pogofilter__toggle" })
], -1)

import { computed, ref } from 'vue'
import { FilterIcon } from './icons'
import { states } from '@/types/state'
import { genres } from '@/types/genre'
import { store } from '@/store'


export default /*#__PURE__*/_defineComponent({
  __name: 'PogoFilter',
  setup(__props) {

const filterOpen = ref(false)
const showForms = computed(() => store.state.filters.showForms)

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["pogofilter", { 'pogofilter--open': filterOpen.value }])
  }, [
    _hoisted_1,
    _createElementVNode("button", {
      class: "pogofilter__toggle",
      onClick: _cache[0] || (_cache[0] = ($event: any) => (filterOpen.value = !filterOpen.value))
    }, [
      _createVNode(_unref(FilterIcon), { class: "pogofilter__icon" })
    ]),
    _hoisted_2
  ], 2))
}
}

})